import React from 'react';
import ModalPopup from './ModalPopup';
import completed from '../../../images/completed.svg';
import failed from '../../../images/failed.svg';

const ResultModal = ({
  isVisible,
  onClose,
  type,
  allowConfirm,
  isInsurance,
}) => {
  // 根據 type 切換顯示
  let title = '';
  let content = null;

  if (type === 'success') {
    title = '預約成功';
    content = (
      <div style={{ textAlign: 'center' }}>
        <img src={completed} />
        <p>您的預約已提交！</p>
      </div>
    );
  } else {
    title = '預約失敗';
    content = (
      <div style={{ textAlign: 'center' }}>
        <img src={failed} />
        <p>
          表單尚未完成
          <br />
          請填寫完整的預約資訊
        </p>
      </div>
    );
  }

  return (
    <ModalPopup
      isVisible={isVisible}
      onClose={onClose}
      title={title}
      content={content}
      allowConfirm={allowConfirm}
      isInsurance={type === 'success' ? isInsurance : false}
    />
  );
};

export default ResultModal;
